import { Controller } from "stimulus"

export default class extends Controller {
  connect () {
    if (!window.$R) return console.log(`Warning: trying to disable Redactor on #${this.element.id}, but cannot because $R is undefined`)

    window.$R(`#${this.element.id}`, 'enableReadOnly')
  }
}
